import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledWhisperSaleBadge = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: -6%;
  left: 10%;
  transform: translateX(-50%);
  width: 41%;

  img {
    width: 100%;
    height: 100%;
    max-height: 80px;
    min-width: 40px;
  }
` as any;

export const StyledWhisperSaleBadgeNumber = styled.div<{
  digitsNumber: number;
}>`
  position: absolute;
  left: ${({ digitsNumber }) => (digitsNumber > 2 ? '45%' : '48%')};
  bottom: 45%;
  transform: translateX(-50%);
  color: #000000;
  font-size: ${({ digitsNumber }) =>
    digitsNumber > 2 ? ' clamp(10px, 1.5vw, 20px)' : 'clamp(12px, 2vw, 24px)'};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: none;
  text-align: center;
` as any;
